import { type FC, useMemo } from "react";

import {
  useGetAccountDocumentRequests,
  useGetCurrentAccountIfLiveElseTradingAccount,
  useGetOwnerDetails,
  useGetOwners,
} from "~/v2/api/hooks";
import type { SettingsTabProps } from "../index";
import { RequestedDocuments } from "./RequestedDocuments";

const DocumentRequests: FC<SettingsTabProps> = () => {
  // TODO (MLA): Review UX
  const { account } = useGetCurrentAccountIfLiveElseTradingAccount();
  const { details } = useGetOwnerDetails();
  const { owners } = useGetOwners({
    accountId: account?.id ?? "",
    options: { enabled: !!account?.id },
  });

  const primaryOwner = useMemo(() => {
    return owners?.find((owner) => owner.primary === true);
  }, [owners]);

  const { data: documentRequests, isLoading } = useGetAccountDocumentRequests({
    accountId: account?.id,
    options: { enabled: !!account?.id },
  });

  if (!account || !details || isLoading) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6">
      <h1 className="font-inter font-medium text-[24px] text-gray-900 leading-[27px] tracking-[0%]">
        Documents Required
      </h1>
      {documentRequests && documentRequests.length > 0 ? (
        <RequestedDocuments
          account={account}
          isLegalEntity={Boolean(primaryOwner?.is_legal_entity)}
          documentRequests={documentRequests}
        />
      ) : (
        <div className="mx-auto max-w-md rounded-lg border border-gray-200 bg-gray-50 p-8 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
            <svg
              aria-hidden="true"
              className="h-8 w-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h3 className="mb-2 font-inter font-medium text-[18px] text-gray-900 leading-[21px] tracking-[0%]">
            No Documents Required
          </h3>
          <p className="font-inter text-[14px] text-gray-600 leading-[20px]">
            Your account is up to date and no additional documents are currently
            required. If any documents are needed in the future, they will
            appear here.
          </p>
        </div>
      )}
    </div>
  );
};

export default DocumentRequests;
